// ContextBar.js
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Transition } from "@headlessui/react";
import GeographyDescription from "../../components/text/GeographyDescription";
import { DemographicFilters } from "./DemographicFilters";
import { contextBarConfig } from "./config";
import { MainScoreContext } from "./MainScoreContext";
import { TurnoutScoreContext } from "./TurnoutScoreContext";
import { EarlyVoteContext } from "./EarlyVoteContext";
import { CommunityHealthContext } from "./CommunityHealthContext";
import { quantum } from "ldrs";

quantum.register();

const ContextBar = ({ queryString }) => {
  const selectedTab = useSelector((state) => state.districtPage.selectedTab);
  const districtName = useSelector((state) => state.districtPage.districtName);
  const [shouldLoadDescription, setShouldLoadDescription] = useState(false);

  useEffect(() => {
    // Only start the timer if district name is loaded
    if (districtName) {
      const timer = setTimeout(() => {
        setShouldLoadDescription(true);
      }, 1000); // 1 second delay

      return () => clearTimeout(timer);
    }
  }, [queryString, districtName]);

  const renderSection = (sectionId) => {
    switch (sectionId) {
      case "overview":
        return shouldLoadDescription ? (
          <GeographyDescription geoQuery={queryString} />
        ) : (
          <div className="text-center">
            <l-quantum size="45" speed="1.75" color="black"></l-quantum>
          </div>
        );
      case "vote_history":
        return <DemographicFilters {...contextBarConfig.sections[sectionId]} />;
      case "scores":
        return <MainScoreContext geoQuery={queryString} />;
      case "turnout_scores":
        return <TurnoutScoreContext geoQuery={queryString} />;
      case "early_vote":
        return <EarlyVoteContext geoQuery={queryString} />;
      case "community_health":
        return <CommunityHealthContext geoQuery={queryString} />;
      default:
        return null;
    }
  };

  const getVisibleSection = () => {
    switch (selectedTab) {
      case "Demographics":
        return "overview";
      case "Vote History":
        return "vote_history";
      case "Scores":
        return "scores";
      case "Turnout Scores":
        return "turnout_scores";
      case "Early Vote":
        return "early_vote";
      case "Community Health":
        return "community_health";
      default:
        return null;
    }
  };

  const visibleSection = getVisibleSection();

  return (
    <aside className="sticky top-48 w-[26em] block relative items-center justify-center">
      {Object.keys(contextBarConfig.sections).map((sectionId) => (
        <Transition
          key={sectionId}
          show={visibleSection === sectionId}
          enter="transition-opacity duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="font-inter text-slate-700 absolute w-full">
            {renderSection(sectionId)}
          </div>
        </Transition>
      ))}
    </aside>
  );
};

export { ContextBar };
